import { deLocalizeUrl } from '$lib/paraglide/runtime';

/**
 * SAM-686: zdejmij prefiks locale (/pl/...) z KAŻDEJ ścieżki przed
 * resolverem route'ów. Poprzednia whitelista ścieżek marketingowych gniła
 * z każdą nową stroną (SAM-671 dodał /features i /pricing, ale nie tutaj)
 * i 404-owała wszystkie zlokalizowane linki — łącznie z CTA rejestracji
 * i logowania, bo localizeHref prefiksuje też /auth/* i /app/*.
 * Przed duplicate content w SEO chronią canonical/hreflang (SAM-361),
 * nie 404-ki.
 */
export const reroute = (request: { url: URL }) => {
	const delocalized = deLocalizeUrl(request.url).pathname;
	// Normalizacja trailing slasha (ale "/" zostaje)
	return delocalized === '/' ? '/' : delocalized.replace(/\/$/, '');
};
